// src/routes/CasetaRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CasetaLayout from '../components/layout/CasetaLayout';
import ModuloGuard from '../components/ModuloGuard';

// Páginas compartidas
import Configuraciones from '../pages/Configuraciones';
import PreguntasFrecuentes from '../pages/PreguntasFrecuentes';
import Soporte from '../pages/Soporte';
import Perfil from '../pages/Perfil';
import Amenidades from '../pages/Amenidades';
import Vigilancia from '../pages/Vigilancia';
import AvisoPrivacidad from '../pages/AvisoPrivacidad';

const CasetaRoutes = () => (
    <Routes>
        <Route element={<CasetaLayout />}>
            <Route index element={<Navigate to="vigilancia" replace />} />
            <Route path="vigilancia" element={<Vigilancia />} />
            <Route path="amenidades" element={
                <ModuloGuard moduloKey="amenidades">
                    <Amenidades />
                </ModuloGuard>
            } />
            <Route path="configuraciones" element={<Configuraciones />} />
            <Route path="configuraciones/faq" element={<PreguntasFrecuentes />} />
            <Route path="configuraciones/soporte" element={<Soporte />} />
            <Route path="configuraciones/perfil" element={<Perfil />} />
            <Route path="aviso-privacidad" element={<AvisoPrivacidad />} />
            <Route path="*" element={<Navigate to="vigilancia" replace />} />
        </Route>
    </Routes>
);

export default CasetaRoutes;
